import TabNavigation from '../../../home/components/navigation/TabNavigation';

export default function HomeLayout() {
    return <TabNavigation />;
}
